export const selectIsFetchingSession = ({ user }) =>
  user?.ui?.isFetchingSession ?? false;
export const selectHasCheckedSession = ({ user }) =>
  user?.ui?.hasCheckedSession ?? false;
export const selectIsFetchingUserProfile = ({ user }) =>
  user?.ui?.isFetchingUserProfile ?? false;
export const selectUserUi = ({ user }) => user?.ui ?? {};
